module.exports = __webpack_public_path__ + "static/media/dropdown-blue.11e03962.svg";